import { batch } from 'react-redux';
import ValidationStatus from '../../Data/ValidationStatus';
import { validatePhoneSaga } from '../../Lib/redux/sagas/ValidatePhone/validatePhone';
import {
  setComponentValidationStatus,
  setPhoneValidationConstraint,
} from '../../Lib/redux/slices/components';
import { handleAnswerQuestionSideEffectsSaga } from '../../Hooks/actionCreators';

/**
 * Handles the validation of a phone number
 *
 * @param {string} componentId
 * @param {string} countryCode - i.e. US / GB / FR
 * @param {fn} dispatch - function to dispatch an action
 * @param {string} iFrameId
 * @param constraints
 * @param {string|int|undefined} formId
 * @param {boolean} isFrontendValidationInvalid - whether the frontend component validation is invalid, if true, the frontend validation is invalid
 * @returns undefined
 */
const validatePhone = ({
  value,
  componentId,
  countryCode,
  dispatch,
  iFrameId,
  constraints,
  formId,
  isFrontendValidationInvalid,
}) => {
  if (isFrontendValidationInvalid) {
    batch(() => {
      dispatch(
        setPhoneValidationConstraint({
          status: ValidationStatus.INVALID,
          componentId,
        })
      );
      dispatch(
        setComponentValidationStatus({
          componentId,
          countryCode,
          iFrameId,
          formId,
        })
      );
    });
  } else if (countryCode === 'GB' || countryCode === 'US') {
    batch(() => {
      dispatch(
        validatePhoneSaga({
          country: countryCode,
          number: value,
          componentId,
          iFrameId,
          constraints,
          formId,
        })
      );
    });
  } else {
    batch(() => {
      dispatch(
        setPhoneValidationConstraint({
          status: ValidationStatus.VALID,
          componentId,
        })
      );
      dispatch(
        setComponentValidationStatus({
          componentId,
          countryCode,
          iFrameId,
          formId,
        })
      );
      dispatch(handleAnswerQuestionSideEffectsSaga({ componentId }));
    });
  }
};

export default validatePhone;
